interface NetJetsCompany {
  readonly companyCode: string;
  readonly companyName: string;
  readonly oktaGroups: ReadonlyArray<string>;
  readonly domain: string;
  readonly flightRequestFormUrl: string;
  readonly emailDomain?: string;
  readonly businessUnitId?: string;
}

interface NetJetsCompanies {
  [key: string]: NetJetsCompany;
}

const officeFormsUrlBase = "https://forms.office.com/Pages/ResponsePage.aspx";
const sharepointUrlBase = "https://netjets.sharepoint.com/teams/ferryreq/_layouts/15/SPListForm.aspx"
const requestFormIdEjm = "j47Wr-Gmn0mWONzuqEeXcsxAQI43i6hKqpijeBsBKXxURFhJSTU3N1c3WkhFS0NDWE5MSDJZWlFUUSQlQCN0PWcu";
const requestFormIdNje = "j47Wr-Gmn0mWONzuqEeXcnnWeQhtVHNCpZkMZwFD0hdUQzM1N0gyOTNGMFU3TFRVVjBaV0pSOVJNQi4u";
const requestFormIdNja = "0ccc7dbf-703a-4ea3-a2c8-7ee3d4b55e7c"


export const netjetsCompanies: NetJetsCompanies = {
  ejm: {
    companyCode: "ejm",
    companyName: "Executive Jet Mgmt",
    oktaGroups: ["OKTA-ActiveEmployees-EJM", "FerryFinderUser-EJM"],
    domain: "luk",
    flightRequestFormUrl: `${officeFormsUrlBase}?id=${requestFormIdEjm}`,
    emailDomain: "ejmjets.com",
    businessUnitId: "EJM-2",
  },
  nja: {
    companyCode: "nja",
    companyName: "NetJets U.S.",
    oktaGroups: ["OKTA-ActiveEmployees-NJA", "FerryFinderUser-NJA"],
    domain: "cmh",
    flightRequestFormUrl: `${sharepointUrlBase}?PageType=8&List=${requestFormIdNja}`,
    businessUnitId: "NJUS-1",
  },
  nje: {
    companyCode: "nje",
    companyName: "NetJets Europe",
    oktaGroups: ["OKTA-ActiveEmployees-NJE", "FerryFinderUser-NJE"],
    domain: "lis",
    flightRequestFormUrl: `${officeFormsUrlBase}?id=${requestFormIdNje}`,
    businessUnitId: "NJE-3",
  },
};

export const netjetsCompaniesArr = Object.values(netjetsCompanies);

export const defaultCompanyCodeUs = netjetsCompanies.nja.companyCode;
export const defaultCompanyCodeEu = netjetsCompanies.nje.companyCode;
